import React, { useState, useEffect } from "react";
import styles from "../../../shared/components/EditarProdutoPopUp.module.css";
import { fetchWithAuth } from "../../../shared/utils/auth";

function EditarProdutoPopUp({ produto, categorias, onClose, onSalvar }) {
  const [nome, setNome] = useState("");
  const [descricao, setDescricao] = useState("");
  const [preco, setPreco] = useState(0);
  const [precoFormatado, setPrecoFormatado] = useState("");
  const [categoria, setCategoria] = useState("");
  const [disponivel, setDisponivel] = useState("sim");
  // '' = sem estoque definido = ilimitado
  const [quantidade, setQuantidade] = useState('');
  // Código deste produto no catálogo do iFood (externalCode). '' = sem vínculo.
  const [codigoIfood, setCodigoIfood] = useState('');

  const formatarPreco = (valor) => {
    const num = parseFloat(valor);
    if (isNaN(num)) return "R$ 0,00";
    return `R$ ${num.toFixed(2).replace('.', ',')}`;
  };

  const handlePrecoChange = (e) => {
    let valor = e.target.value.replace(/\D/g, '');
    if (!valor) {
      setPreco(0);
      setPrecoFormatado('');
      return;
    }
    const centavos = parseInt(valor, 10);
    const reais = (centavos / 100).toFixed(2);
    setPreco(parseFloat(reais));
    setPrecoFormatado(`R$ ${reais.replace('.', ',')}`);
  };

  useEffect(() => {
    if (produto) {
      setNome(produto.nome_item || "");
      setDescricao(produto.descricao || "");
      setPreco(produto.preco || 0);
      setPrecoFormatado(formatarPreco(produto.preco));
      setCategoria(produto.id_categoria || "");
      setDisponivel(produto.disponivel || "sim");
      setQuantidade(produto.quantidade === null || produto.quantidade === undefined ? '' : produto.quantidade);
      setCodigoIfood(produto.ifood_external_code || '');
    }
  }, [produto]);

  const handleSalvar = async () => {
    if (!nome || nome.trim() === "") {
      alert("O nome do produto é obrigatório.");
      return;
    }

    if (!categoria && categoria !== 0) {
      alert("Selecione uma seção.");
      return;
    }

    // "" (campo em branco) = estoque ilimitado
    const quantidadeParaSalvar = quantidade === '' ? null : Number(quantidade);

    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const payload = {
        id_item: produto.id_item,
        nome_item: nome,
        descricao,
        preco,
        id_categoria: categoria,
        disponivel,
        quantidade: quantidadeParaSalvar,
        ifood_external_code: codigoIfood.trim() === '' ? null : codigoIfood.trim(),
      };
      console.log('Payload enviado para atualizar produto:', payload);

      const res = await fetchWithAuth(`${API_URL}/atualizar-item-produto`, {
        method: "POST",
        body: JSON.stringify(payload),
      });

      if (!res) {
        // Token expirado ou inválido - fetchWithAuth já fez logout
        return;
      }

      const data = await res.json();
      if (data.success) {
        onSalvar({
          ...produto,
          nome_item: nome,
          descricao,
          preco,
          id_categoria: categoria,
          disponivel,
          quantidade: quantidadeParaSalvar,
          ifood_external_code: codigoIfood.trim() === '' ? null : codigoIfood.trim(),
        });
        onClose();
      } else {
        alert("Erro ao salvar: " + data.message);
      }
    } catch (error) {
      console.error(error);
      alert("Erro ao salvar produto.");
    }
  };

  if (!produto) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <h2>Editar Produto</h2>

        <label>Nome:</label>
        <input value={nome} onChange={(e) => setNome(e.target.value)} />

        <label>Descrição:</label>
        <textarea value={descricao} onChange={(e) => setDescricao(e.target.value)} />

        <label>Preço:</label>
        <input
          type="text"
          value={precoFormatado}
          onChange={handlePrecoChange}
          placeholder="R$ 0,00"
        />

        <label>Seção:</label>
        <select value={categoria} onChange={(e) => setCategoria(Number(e.target.value))}>
          {categorias.map((cat) => (
            <option key={cat.id_categoria} value={cat.id_categoria}>
              {cat.nome_categoria}
            </option>
          ))}
        </select>

        <div className={styles.checkboxContainer}>
          <input
            type="checkbox"
            checked={disponivel === "sim"}
            onChange={(e) => setDisponivel(e.target.checked ? "sim" : "nao")}
          />
          <label>Disponível</label>
        </div>

        <label>Quantidade em estoque:</label>
        <input
          type="number"
          min={0}
          placeholder="Deixe em branco para estoque ilimitado"
          value={quantidade}
          onChange={(e) => setQuantidade(e.target.value === '' ? '' : Number(e.target.value))}
        />

        <label>Código no iFood (externalCode):</label>
        <input
          type="text"
          maxLength={60}
          placeholder="Opcional — liga este produto aos pedidos do iFood"
          value={codigoIfood}
          onChange={(e) => setCodigoIfood(e.target.value)}
        />

        <div className={styles.botoes}>
          <button onClick={onClose}>Cancelar</button>
          <button onClick={handleSalvar}>Salvar</button>
        </div>
      </div>
    </div>
  );
}

export default EditarProdutoPopUp;
